import { ContextMenuLink, Icon, Text } from "@seneca/senekit";

import { linkToDarkModeGating } from "common/links";

type Props = {
  onClick?: () => void;
};

export default function DarkModeGatingMenuOption({ onClick }: Props) {
  return (
    <ContextMenuLink to={linkToDarkModeGating()} onClick={onClick}>
      {{
        icon: (
          <Icon
            iconName="lock"
            size="medium"
            accessibilityLabel={null}
            tone="neutral"
          />
        ),
        text: <Text>Dark mode</Text>
      }}
    </ContextMenuLink>
  );
}
